export default __webpack_public_path__ + "static/media/weglowodany-icon.3e0f2f3a.svg";